import React from 'react'
import _ from 'lodash'
import Promise from 'bluebird'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import classNames from 'classnames'

import {
  fetchTowns,
  fetchListings,
  exportPortal,
} from '../../../modules/portal-remote/portalService'
import { Searchbar } from '../../views/widgets/Searchbar'
import { toast } from 'react-toastify'
import { setPortal } from '../../../actions/portal'

export function mergeExport(initializeRelations, relations) {
  const groupRelations = _.reduce(
    relations,
    (prev, relation) => {
      prev = _.union(prev, relation)
      return prev
    },
    [],
  )

  let groupInitialRelations = _.reduce(
    initializeRelations,
    (prev, relation) => {
      prev = _.union(prev, relation)
      return prev
    },
    [],
  )

  const exportListingAction = {
    pushList: [],
    pullList: [],
    groupInitialRelations,
  }
  _.each(groupRelations, relation => {
    const listings = initializeRelations[relation.townRef]
    const isHaveListings = _.some(listings, { listingRef: relation.listingRef })
    if (listings && isHaveListings) {
    } else {
      exportListingAction['pushList'].push(relation)
    }
    groupInitialRelations = _.reject(groupInitialRelations, {
      listingRef: relation.listingRef,
      townRef: relation.townRef,
    })
  })

  _.extend(exportListingAction['pullList'], groupInitialRelations)
  return exportListingAction
}

class PortalExportContainer extends React.Component {
  static defaultProps = {
    language: 'th',
  }

  state = {
    towns: [],
    listings: {},
    recentTowns: [],
    exportTowns: [],
    relations: [],
  }

  componentDidMount() {
    this.handleInitialize()
  }

  handleInitialize = async () => {
    const towns = await fetchTowns()

    //init townRefs
    const townRefs = _.take(
      [
        ...(this.props.townRefs || []),
        ...(_.get(this.props, 'user.availableTowns') || []),
      ],
      5,
    )
    const recentTowns = _.reject(towns, town => _.includes(townRefs, town._id))

    //loading listings
    const groupListingByTown = await this.getInitializeListings(townRefs)
    const initializeRelations = this.handleInitialRelations(
      townRefs,
      groupListingByTown,
      this.props.portalID,
    )

    console.info('initialize finish...')
    this.setState({
      recentTowns,
      towns,
      groupListingByTown,
      initializeRelations,
      relations: initializeRelations,
    })
  }

  handleInitialRelations = (townRefs, groupListingByTown, hostRef) => {
    return _.reduce(
      townRefs,
      (prev, townRef) => {
        prev[townRef] = this.handleInitialRelation(
          townRef,
          groupListingByTown,
          hostRef,
        )
        return prev
      },
      {},
    )
  }

  handleInitialRelation = (townRef, groupListingByTown, hostRef) => {
    const listings = _(groupListingByTown[townRef])
      .filter(listing => _.some(listing.portals, { hostRef }))
      .map(listing => ({
        listingRef: listing._id,
        hostRef,
        townRef,
      }))
      .value()
    return listings
  }

  getInitializeListings = async townRefs => {
    if (_.isEmpty(townRefs)) {
      return Promise.resolve([])
    }

    const listings = Promise.reduce(
      townRefs,
      async (prev, townRef) => {
        prev[townRef] = await fetchListings({town: townRef})
        return prev
      },
      {},
    )
    return listings
  }

  isListingChecked = (townRef, listingRef) =>
    _.some(this.state.relations[townRef], {
      listingRef: listingRef,
    })

  findTownByTownRef = townRef => _.find(this.state.towns, { _id: townRef })

  findListingByListingRef = (listingRef, townRef) =>
    _.find(this.state.groupListingByTown[townRef], { _id: listingRef })

  handleTownAdd = async town => {
    //step1: reject townID
    const recentTowns = _.reject(this.state.recentTowns, { _id: town._id })

    //step2: add listings from new townID
    const listings = await fetchListings({town: town._id})

    this.setState(
      prevState => ({
        recentTowns,
        groupListingByTown: {
          ...prevState.groupListingByTown,
          [town._id]: listings,
        },
      }),
      () => {
        //step3: create relation from new townID and update initize relation
        //step4: update relations from new relation
        const relation = this.handleInitialRelation(
          town._id,
          this.state.groupListingByTown,
          this.props.portalID,
        )
        this.setState(prevState => ({
          initializeRelations: {
            ...prevState.initializeRelations,
            [town._id]: relation,
          },
          relations: {
            ...prevState.relations,
            [town._id]: relation,
          },
        }))
      },
    )
  }

  handleTownDelete = townRef => {
    //step1: find town from towns
    const town = _.find(this.state.towns, { _id: townRef })

    //step2: add town to recentTowns
    //step3: omit town from relations
    this.setState(prevState => ({
      recentTowns: [...prevState.recentTowns, town],
      relations: _.omit(prevState.relations, [townRef]),
    }))
  }

  handleListingToggle = (listing, townRef) => {
    if (this.isListingChecked(townRef, listing._id)) {
      // reject object
      this.setState(prevState => ({
        relations: {
          ...prevState.relations,
          [townRef]: _.reject(prevState.relations[townRef], {
            listingRef: listing._id,
          }),
        },
      }))
    } else {
      // create object
      this.setState(prevState => ({
        relations: {
          ...prevState.relations,
          [townRef]: [
            ...prevState.relations[townRef],
            {
              listingRef: listing._id,
              hostRef: this.props.portalID,
              townRef,
            },
          ],
        },
      }))
    }
  }

  handleExport = async () => {
    const { initializeRelations, relations } = this.state
    const exportListings = mergeExport(initializeRelations, relations)
    const portalID = this.props.portalID
    try {
      const { portalHost } = await exportPortal(portalID, exportListings)
      this.props.actions.setPortal(portalHost)

      toast.success('handleExport completed')
      this.handleInitialize()
    } catch (error) {
      toast.error('handle Export: ' + error.message)
    }
  }

  renderListingItem = (listing, townRef) => {
    const isChecked = this.isListingChecked(townRef, listing._id)

    return (
      <a
        key={listing._id}
        className={classNames('panel-block', { 'is-active': isChecked })}
        onClick={() => this.handleListingToggle(listing, townRef)}
      >
        <span
          className="panel-icon"
          key={isChecked ? 'far fa-check-square' : 'far fa-square'}
        >
          <i
            className={isChecked ? 'far fa-check-square' : 'far fa-square'}
            aria-hidden="true"
          />
        </span>
        {listing.title.th}
      </a>
    )
  }

  render() {
    const isNotRelation =
      _.isEmpty(this.state.initializeRelations) &&
      _.isEmpty(this.state.relations)

    const isEqualRelations = _.isEqual(
      this.state.initializeRelations,
      this.state.relations,
    )

    console.log(
      _.isEqual(this.state.initializeRelations, this.state.relations),
      this.state.initializeRelations,
      this.state.relations,
    )

    if (_.isEmpty(this.state.towns)) {
      return null
    }

    return (
      <div>
        <div className="has-text-right">
          <button
            disabled={isNotRelation}
            className={classNames(
              'button',
              this.props.isRecentExport && isEqualRelations
                ? 'is-default'
                : 'is-primary',
            )}
            onClick={this.handleExport}
          >
            EXPORT
          </button>
        </div>
        <hr />
        {/* search section */}
        <div className="card">
          <div className="card-content">
            <Searchbar
              values={this.state.recentTowns}
              searchField={`title.th`}
              labelField={`title.th`}
              onItemClick={this.handleTownAdd}
              placeholder={'search town...'}
            />
          </div>
        </div>

        {/* end search section */}
        {/* town section */}
        {_.map(this.state.relations, (listings, townRef) => {
          const town = this.findTownByTownRef(townRef)
          return (
            <div className="card" key={townRef}>
              <div className="card-content">
                <article className="media">
                  <div className="media-content">
                    <p className="title is-4">
                      {_.get(town, `title.${this.props.language}`)}
                    </p>
                  </div>
                  <div className="media-right">
                    <button
                      className="delete"
                      onClick={() => this.handleTownDelete(townRef)}
                    />
                  </div>
                </article>
                <nav className="panel">
                  {_.isEmpty(this.state.groupListingByTown[townRef]) && (
                    <h3> Listing Not available</h3>
                  )}
                  {_.map(this.state.groupListingByTown[townRef], listing =>
                    this.renderListingItem(listing, townRef),
                  )}
                </nav>
              </div>
            </div>
          )
        })}
        {/* end town section */}
      </div>
    )
  }
}

export default connect(
  ({ portal, info: { language }, auth: { user } }) => ({
    townRefs: portal.townRefs,
    isRecentExport: portal.modifiedDate === portal.exportedDate,
    language,
    user,
  }),
  dispatch => ({
    actions: bindActionCreators({ setPortal: setPortal }, dispatch),
  }),
)(PortalExportContainer)



// WEBPACK FOOTER //
// ./src/components/templates/portal-export/PortalExportContainer.js